import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-circle-progress',
    templateUrl: './circle-progress.component.html',
    styleUrls: ['./circle-progress.component.scss']
})

export class CircularProgressComponent implements OnInit, OnChanges{
    @Input() progress: number;
    ngOnInit(): void {
        this.loadData();
    }
    loadData() {
        const scrollProgress = document.getElementById('progress');
        scrollProgress.style.background = `conic-gradient(#10082F ${this.progress}%, #f2f2f4 ${this.progress}%)`;
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.loadData();
    }
}
